export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5635.1e3cd59c.jpg";